













































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import i18n from '@/services/i18n';
import { Ax } from '@/utils';
import { SingleBudgetProgramField } from '../budget-programs';
import { SingleBudgetVariantField } from '../budget-variants';
import * as common from '../common';
import { ComponentBase, Overlay, SvgIcon } from '../components';
import { SingleOrgField } from '../organizations';
import { BudgetVariants, Comp, Dict, Org, Report, Report2, Version } from '../types';
import { SingleVersionField } from '../versions';
import axios from "axios";
import {generateExpression} from "@/modules/budget/staffing-table/reports/templates/expressionHelper";
import {staffTabAccess} from "../common";
import CurYearField from "@/modules/budget/staffing-table/components/CurYearField.vue";
import ConfirmModal from "@/modules/budget/staffing-table/components/ConfirmModal.vue";


const events = {
    reportSaved: 'report-saved',
};

const translates = {
    tools: {
        buttons: {
            get downloadReport(): string {
                return i18n.choose(
                    'Скачать',
                    'Жүктеп алу',
                    'Download',
                );
            },
            get generateReport(): string {
                return i18n.choose(
                    'Сформировать',
                    'Пішін',
                    'Generate',
                );
            },
            get downloadTarificationReport(): string {
                return i18n.choose(
                    'Тарификационный список',
                    'Тарификациялық тізім',
                    'Tarification Report',
                );
            },
            get downloadStaffTabReport(): string {
                return i18n.choose(
                    'Штатное расписание',
                    'Штаттық кесте',
                    'Staffing table report',
                );
            },
            get clearBudgetProg(): string {
                return i18n.choose(
                    'Сбросить бюджетную программу',
                    'Сбросить бюджетную программу (каз)',
                    'Reset Budget Program',
                );
            },
        }
    },
    errors: {
        get cannotLoadBudgetSubprograms(): string {
            return i18n.choose(
                'Cannot load budget subprograms',
                'Не удалось загрузить бюджетные подпрограммы (каз)',
                'Не удалось загрузить бюджетные подпрограммы',
            );
        },
    },
    fields: {
        budgetSubprogram: {
            get title(): string {
                return i18n.choose(
                    'Бюджетная подпрограмма',
                    'Бюджетная подпрограмма (каз)',
                    'Budget subprogram',
                );
            },
            get emptyValue(): string {
                return i18n.choose(
                    '[ Нет значения ]',
                    '[ Нет значения ] (каз)',
                    '[ No value ]',
                );
            },
        },
    },
};

interface ReportSettings {
    budgetVariantUUID: string ;
    abpCode: number;
    staffTabVersionId: number;
    budgetProgramCode: number | null;
    detailedReport: boolean
    debug: boolean
}

@Component({
    components: {
        ConfirmModal,
        Overlay,
        SingleBudgetProgramField,
        SingleBudgetVariantField,
        SingleOrgField,
        SingleVersionField,
        SvgIcon,
        CurYearField
    },
})
/** @deprecated Используй GenerationPaneBase.vue */
export default class GenerationPane extends ComponentBase {
    constructor() {
        super('modules.budget.staffing_table.reports.*XlsxGenerationPane*');
    }
    // Ключ индивидуального сводного отчета
    private SVD_IND = "SVD_IND"

    // Доступ к редактированию данных
    get isEditable(): boolean {
        return staffTabAccess.isEditable;
    }

    // region Lifecycle
    protected created() {
        super.created();

        this.reportYearString = this.reportYear.toString();

        // region Данные
        this.$watch('org', (org: Org | null) => {
            common.store.org = org;
            common.store.conditionExp = null
            this.ebkFunc = common.store.abp;
            this.resetVersion()
            this.resetBudgetProgram()
            this.resetBudgetVariant()
        });
        this.$watch('requiredRegionCode', (/* requiredRegionCode: string | null */) => {
            this.reloadRegion();
        });
        this.$watch('version', (version: Version | null) => {
            common.store.version = version;
            if (!this.reportYearIsChanged) {
                this.upDateConditionExp();
            }
        });
        this.$watch('reportYear', async (reportYear: number) => {
            this.reportYearIsChanged = true
            common.store.reportYear = reportYear;
            common.store.conditionExp = null
            await this.updateBudgetVariant(this.org)
            await this.loadInitialBudgetProgram();
            await this.reloadSpecificities();
            this.upDateConditionExp();
            this.reportYearIsChanged = false

        });
        this.$watch('reportYearString', (/* reportYearString: string */) => {
            this.readReportYearString();
            this.resetBudgetVariant();
        });
        this.$watch('budgetVariant', (budgetVariant: BudgetVariants | null) => {
            common.store.budgetVariant = budgetVariant;
            if (budgetVariant) {
                if (!this.reportYearIsChanged) {
                    this.upDateConditionExp();
                }
            }
        });

        this.$watch('budgetProgram', (budgetProgram: Dict.EbkFunc | null, oldBudgetProgram: Dict.EbkFunc | null) => {
            common.store.budgetProgram = budgetProgram;

            const code = budgetProgram?.prg ?? null;
            const oldCode = oldBudgetProgram?.prg ?? null;
            if (code !== oldCode) {
                this.resetBudgetSubprograms()
            }
                this.loadBudgetSubprograms();

            if (!this.reportYearIsChanged) {
                this.upDateConditionExp();
            }
        });
        this.$watch('budgetSubprogram', (budgetSubprogram: Dict.EbkFunc | null) => {
            common.store.budgetSubprogram = budgetSubprogram;
        });
        this.$watch('specificity', (specificity: Dict.EbkEk | null) => {
            common.store.specificity = specificity;

            const specificityCode = specificity?.spf ?? null;
            if (specificityCode === null) {
                this.form = null;
            } else {
                const forms = common.specificityToReportFormKeyMap.get(specificityCode);
                // noinspection JSIncompatibleTypesComparison
                if (forms === undefined) {
                    this.form = null;
                } else {
                    const index = forms.findIndex((testedForm) => (testedForm === this.form));
                    if (index < 0) {
                        this.form = null;
                    }
                }
            }
            if ((!this.reportYearIsChanged) && (this.templateKeyIsSpecific)) {
                this.upDateConditionExp();
            }
        });
        this.$watch('form', (form: Report.FormKey | null) => {
            common.store.form = form;
            if ((!this.reportYearIsChanged) && (this.templateKeyIsForm)) {
                this.upDateConditionExp();
            }
        });
        // endregion
    }

    protected mounted() {
        super.mounted();
        this.reloadRegion();
        this.loadInitialBudgetProgram();
        this.reloadSpecificities();

        if (this.budgetProgram !== null) {
            this.loadBudgetSubprograms();
        }
    }
    // endregion


    // region Утилиты
    public translates = translates;

    private get isEducationAbp(): boolean {
        return (
            (this.ebkFunc?.abp === 261)
            ||
            (this.ebkFunc?.abp === 360)
        );
    }

    private cleanBudgetProgram() {
        this.budgetProgram = null
    }

     get versionIsNotNull(): boolean {
        return (this.version != null);
    }

     get canDownloadResponse(): boolean {
        return (this.budgetVariant !== null) && (this.budgetProgram !== null) && (this.form !== null) && (this.version !== null)
    }

    public ebkFunc: Dict.EbkFunc | null = common.store.abp;

    public get generationAndSavingForbidden(): boolean {
        return this.budgetVariantForbiddenForGenerationAndSending || this.detailedReport || this.debugging || (!this.isActualVariant);
    }
    // endregion

    public upDateConditionExp() {
        const conditionExp = generateExpression(this.templateKey)
        if (conditionExp != null) {
            this.$emit('update-condition', conditionExp, this.templateKey);
        }
    }


    // region Общие данные
    public get loading(): boolean {
        return (this.regionLoading || this.budgetVariantLoading || this.budgetProgramLoading || this.budgetSubprogramLoading || this.specificitiesLoading || this.generatingAndSavingReport);
    }

    public get year(): number | null {
        const version = this.version;
        if (version === null) {
            return null;
        } else {
            return version.year;
        }
    }
    // endregion


    // region Организация, ГУ, КГКП, АБП
    public org: Org | null = common.store.org;

    public get kgkp(): Dict.GuKgkp | null {
        const org = this.org;
        if ((org === null) || (org.type !== 'KGKP')) {
            return null;
        }
        return org.kgkp;
    }

    public get gu(): Dict.Gu | null {
        const org = this.org;
        if (org === null) {
            return null;
        }

        const type = org.type;
        switch (org.type) {
            case 'KGKP':
                return org.gu;
            case 'GU':
                return org.gu;
            default:
                console.error(`Unexpected org type \"${type}\"`);
                return null;
        }
    }

    public get guText(): string | null {
        const gu = this.gu;
        if (gu === null) {
            return null;
        }

        const title = this.localize(
            () => (gu.nameEn ?? gu.nameRu),
            () => (gu.nameKk ?? gu.nameRu),
            () => (gu.nameRu),
        )

        return `${gu.code} - ${title}`;
    }

    public get abpCode(): number | null {
        const guCode = this.gu?.code ?? null;

        if (guCode === null) {
            return null;
        }
        if (guCode.length < 3) {
            return null;
        }

        const abpCodeString = guCode.substring(0, 3);
        const abpCode = parseInt(abpCodeString);

        if (String(abpCode) !== abpCodeString) {
            console.error(`GU code "${guCode}" contains invalid ABP code "${abpCodeString}"`);
            return null;
        }
        return abpCode;
    }
    // endregion


    // region Регион
    public get requiredRegionCode(): string | null {
        const gu =  this.gu;
        if (gu === null) return null;

        let result: string;
        if (gu.budgetType === '02') {
            const idRegion = gu.idRegion;
            const idRegionPart = (
                idRegion.length > 2 ?
                    idRegion.substr(0, 2)
                    :
                    idRegion
            );
            result = idRegionPart + '0101';
        } else {
            result = gu.idRegion;
        }

        return result;
    }

    public regionLoading = false;
    public region: Dict.BudgetRegions | null = null;

    public get regionCode(): string | null {
        const region = this.region;
        if (region === null) {
            return null;
        }
        return region.code;
    }

    public get regionText(): string | null {
        const region = this.region;
        if (region === null) {
            return null;
        }

        const title = this.localize(
            () => (region.nameRu ?? region.code ?? region.id?.toString() ?? ''),
            () => (region.nameKk ?? region.nameRu ?? region.code ?? region.id?.toString() ?? ''),
            () => (region.nameRu ?? region.code ?? region.id?.toString() ?? ''),
        );

        const code = (region.code ?? region.id?.toString() ?? '');

        return `${code} - ${title}`;
    }

    public reloadRegion() {
        if (this.regionLoading) {
            console.error('Cannot reload region - another loading is running');
            return;
        }

        const requiredRegionCode = this.requiredRegionCode;
        if (requiredRegionCode === null) {
            console.error('Cannot load region - required region code is null');
            return;
        }

        this.regionLoading = true;
        this.region = null;
        this.request<Dict.BudgetRegions | null>(
            { url: `/api/budget/staffing_table/budget-regions/by-code/${requiredRegionCode}` },
            (data) => {
                this.region = data;
            },
            'Error while loading region',
            () => {
                this.regionLoading = false;
            },
        )
    }
    // endregion

   // region Активный шаблон запроса
     templateKey = common.store.templateKey

   get templateKeyIsForm(): boolean {
        return  this.templateKey === 'form-reports'
   }
    get templateKeyIsSpecific(): boolean {
        return  this.templateKey === 'specificity-reports'
    }

    // region Версия
    public version: Version | null = common.store.version;
    // endregion


    // region Год отчета
    public reportYear: number = Number(common.store.reportYear)
    public reportYearString: string = '';
    public reportYearIsChanged = false

    onReportYearChange(value: number) {
        this.reportYearString = value.toString();
    }

    onUpdateVariant() {
        this.updateBudgetVariant(this.org)
    }

    public readReportYearString() {
        try {
            const number = parseInt(this.reportYearString);
            if (!Number.isSafeInteger(number)) {
                return;
            }
            if (number.toString(10) !== this.reportYearString.trim()) {
                return;
            }
            this.reportYear = number;
        } catch (e) {}
    }
    // endregion

    private resetBudgetVariant() {
        this.budgetVariant = null
    }

    private resetVersion() {
        this.version = null
    }

    private resetBudgetProgram() {
        this.budgetProgram = null
    }

    private resetBudgetSubprograms() {
        this.budgetSubprograms = []
        this.budgetSubprogram = null;
    }

    // region Версия бюджета
    public budgetVariantLoading = false;
    public budgetVariant: BudgetVariants | null = common.store.budgetVariant;
    public budgetVariantInitCancelled = false;

    private get isActualVariant(): boolean {
        return (this.budgetVariant !== null) && (this.budgetVariant?.attribute === true) && (!this.budgetVariant.status);
    }

    public get budgetVariantForbiddenForGenerationAndSending(): boolean {
        const budgetVariant = this.budgetVariant;
        if (budgetVariant === null) {
            return false;
        }

        const budgetVariantYear = budgetVariant.year;
        if (budgetVariantYear === null) {
            return false;
        }

        const reportYear = this.reportYear;
        return (budgetVariantYear !== reportYear);
    }

    public loadInitialBudgetVariant() {
        const initialBudgetVariant = common.store.budgetVariant;
        if (initialBudgetVariant === null) {
            return;
        }

        if (this.budgetVariantLoading) {
            console.error('Cannot load initial budget variant - another loading is running');
            return;
        }

        if (this.org === null) {
            console.error('Cannot load initial budget variant - organization is not selected');
            return;
        }

        const orgCode = this.org.org.code;
        const year = this.reportYear
        this.budgetVariantLoading = true;

        const url = this.prepareUrl(
            `/api/budget/staffing_table/budget-variants/by-org-active-date`,
            [
                ['org-code', orgCode],
                ['year', year],
            ]
        );
        Ax<Array<BudgetVariants>>(
            { url },
            (data) => {
                if (this.budgetVariantInitCancelled) {
                    return;
                }

                const index = data.findIndex((budgetVariant) => (budgetVariant.variantUuid === initialBudgetVariant.variantUuid));
                if (index >= 0) {
                    this.budgetVariant = initialBudgetVariant;
                }
            },
            (error) => {
                this.toast(
                    'danger',
                    this.i18n.translate('errors.cannot_load_budget_variants'),
                    error.toString(),
                );
            },
            () => {
                this.budgetVariantLoading = false;
            },
        );
    }

    async updateBudgetVariant(org: Org | null) {
        this.budgetVariant = org ? (await this.setActualVariant()) ?? null : null;
    }

     async setActualVariant(): Promise<BudgetVariants | null> {
         this.budgetVariantLoading = true;
         const initialBudgetVariant = common.store.budgetVariant;

        const orgCode = this.org?.org.code;
        const year = this.reportYear
        const url = this.prepareUrl(
            '/api/budget/staffing_table/budget-variants/by-org-active-date',
            [
                ['org-code', orgCode],
                ['year', year],
            ],
        );
        try {
            const response = await axios.get<Array<BudgetVariants>>(url);
            if (initialBudgetVariant != null) {
                const index = response.data.findIndex((budgetVariant) => budgetVariant.id === initialBudgetVariant.id);
                if (index >= 0) {
                    return initialBudgetVariant;
                }
            }

            return response.data.find(variant => variant.attribute) ?? response.data[0] ?? null;

        } catch (error) {
            console.error(`Error retrieving the actual variant for the year ${year}:`, error);
            return null;
        }
        finally {
            this.budgetVariantLoading = false;
        }
    }
    // endregion


    // region Бюджетная программа
    public budgetProgramLoading = false;
    public budgetProgram: Dict.EbkFunc | null = common.store.budgetProgram;
    public budgetProgramInitCancelled = false;

    public async loadInitialBudgetProgram() {
        const initialBudgetProgram = common.store.budgetProgram;
        if (initialBudgetProgram === null) {
            return;
        }

        if (this.budgetProgramLoading) {
            console.error('Cannot load initial budget program - another loading is running');
            return;
        }

        const reportYear = this.reportYear;
        const abpCode = this.abpCode;
        if (abpCode === null) {
            console.error('Cannot load initial budget program - ABP code is null');
            return;
        }

        this.budgetProgramLoading = true;

        const url = this.prepareUrl(
            `/api/budget/staffing_table/budget-programs`,
            [
                ['abp-code', abpCode],
                ['year', reportYear],
            ]
        );

        try {
            const data = await axios.get<Array<Dict.EbkFunc>>(url);

            if (this.budgetProgramInitCancelled) {
                return;
            }

            const index = data.data.findIndex((budgetProgram) => budgetProgram.id === initialBudgetProgram.id);
            if (index >= 0) {
                this.budgetProgram = initialBudgetProgram;
            } else {
                this.budgetProgram = null
            }
        } catch (error) {
            this.toast(
                'danger',
                this.i18n.translate('errors.cannot_load_budget_programs'),
                error.toString(),
            );
        } finally {
            this.budgetProgramLoading = false;
        }
    }
    // endregion


    // region Бюджетная подпрограмма
    public budgetSubprogramLoading = false;
    public budgetSubprograms: Array<Dict.EbkFunc> = [];
    public budgetSubprogram: Dict.EbkFunc | null = common.store.budgetSubprogram;

    public loadBudgetSubprograms() {
        if (this.budgetSubprogramLoading) {
            console.error('Cannot load budget subprograms - another loading is running');
            return;
        }

        const budgetProgram = this.budgetProgram;
        if (budgetProgram === null) {
            console.error('Cannot load budget subprograms - budget program is NULL');
            return;
        }

        const year = this.reportYear;
        if (year === null) {
            console.error('Cannot load budget subprograms - year is NULL');
            return;
        }
        const funcGroupCode = budgetProgram.gr!!;
        const funcSubgroupCode = budgetProgram.pgr!!;
        const abpCode = budgetProgram.abp!!;
        const budgetProgramCode = budgetProgram.prg!!;
        const date = new Date(year, 0, 1, 0, 0, 0, 0).getTime();

        const url = this.prepareUrl(
            '/api/budget/staffing_table/report/budget-subprograms',
            [
                ['func-group-code', funcGroupCode],
                ['func-subgroup-code', funcSubgroupCode],
                ['abp-code', abpCode],
                ['budget-program-code', budgetProgramCode],
                ['date', date],
            ],
        );

        this.budgetSubprogramLoading = true;
        const oldBudgetSubprogram = this.budgetSubprogram;
        this.budgetSubprogram = null;
        this.budgetSubprograms = [];

        this.request<Array<Dict.EbkFunc>>(
            { url },
            (data) => {
                let newBudgetSubprogram: Dict.EbkFunc | null = null;
                if (oldBudgetSubprogram !== null) {
                    const index = data.findIndex((budgetSubprogram) => (budgetSubprogram.id === oldBudgetSubprogram.id));
                    if (index >= 0) {
                        newBudgetSubprogram = data[index];
                    }
                }
                this.budgetSubprograms = data;
                this.budgetSubprogram = newBudgetSubprogram;
            },
            () => (translates.errors.cannotLoadBudgetSubprograms),
            () => {
                this.budgetSubprogramLoading = false;
            },
        );
    }

    public getBudgetSubprogramTitle(item: Dict.EbkFunc): string {
        let code = (item.ppr!!).toString();
        while (code.length < 3) {
            code = '0' + code;
        }

        const name = i18n.choose(
            () => (item.nameRu ?? item.id!!.toString()),
            () => (item.nameKk ?? item.nameRu ?? item.id!!.toString()),
            () => (item.nameRu ?? item.id!!.toString()),
        )();

        return `${code} - ${name}`;
    }
    // endregion


    // region Специфика/форма
    public specificityToReportFormKeyMap = common.specificityToReportFormKeyMap;

    public specificitiesLoading = false;

    public specificities: Array<Dict.EbkEk> = [];

    public get specificityOptions(): Array<Comp.DropdownItemDef<Dict.EbkEk>> {
        const result: Array<Comp.DropdownItemDef<Dict.EbkEk>> = [];

        this.specificities.forEach((specificity) => {
            const code = ((): string => {
                let result = String(specificity.spf);
                while (result.length < 3) {
                    result = '0' + result;
                }
                return result;
            })();

            const name = this.localize(
                () => (specificity.nameRu || ''),
                () => (specificity.nameKk || ''),
                () => (specificity.nameRu || ''),
            );

            result.push({
                text: `${code} - ${name}`,
                value: specificity,
            });
        });

        return result;
    }

    public specificity: Dict.EbkEk | null = common.store.specificity;

    public async reloadSpecificities() {
        if (this.specificitiesLoading) {
            console.error('Cannot load specificities - another loading is running');
            return;
        }

        const codes = common.specificityCodes;
        const reportYear = this.reportYear;

        this.specificities = [];
        this.specificitiesLoading = true;

       const url = this.prepareUrl(
            '/api/budget/staffing_table/specificities',
            [
                ['codes', codes],
                ['year', reportYear],
            ],
        );

        try {
            const data = await axios.get<Array<Dict.EbkEk>>(url);
            this.specificities = data.data.sort((specificity1, specificity2): number => {
                const code1 = specificity1.spf ?? 0;
                const code2 = specificity2.spf ?? 0;
                return code1 - code2;
            });

            if (this.specificity !== null) {
                const id = this.specificity.id;
                const index = this.specificities.findIndex(
                    (loadedSpecificity) => loadedSpecificity.id === id
                );
                this.specificity = index >= 0 ? this.specificities[index] : null;
            }
        } catch (error) {
            this.toast(
                'danger',
                this.i18n.translate('cannot_load_specificities'),
                error.toString(),
            );
        } finally {
            this.specificitiesLoading = false;
        }
    }

    public get formOptions(): Array<Comp.DropdownItemDef<Report.FormKey>> {
        const result: Array<Comp.DropdownItemDef<Report.FormKey>> = [];

        const specificity = this.specificity?.spf ?? null;
        if (specificity !== null) {
            const forms = this.specificityToReportFormKeyMap.get(specificity);
            // noinspection JSIncompatibleTypesComparison
            if (forms !== undefined) {
                forms.forEach((form) => {
                    let code = String(form);
                    if (code.toUpperCase().startsWith('F_')) {
                        code = code.substring(2);
                    }
                    code = code.replaceAll('_', '-');

                    result.push({
                        text: code,
                        value: form,
                    });
                });
            }
        }

        return result;
    }

    public form: Report.FormKey | null = common.store.form;
    public onFormChanged(form: Report.FormKey | null | undefined) {
        this.form = form ?? null;
    }
    // endregion


    // region Расширенный отчет, отладка
    public detailedReport = false;

    public debugging = false;
    // endregion


    // region Действия
    private generateReportUsingSettings(
        action: (
            regionCode: string,
            budgetVariantUUID: string,
            budgetProgramCode: number,
            budgetSubprogramCode: number | null,
            form: Report.FormKey,
            versionId: number,
            reportYear: number,
            debugging: boolean,
            reportType: ('COMMON' | 'DETAILED'),
        ) => unknown,
    ) {
        const regionCode = this.region?.code ?? null;
        if (typeof regionCode !== 'string') {
            console.error('Cannot define region');
            return;
        }

        const budgetVariantUUID = this.budgetVariant?.variantUuid;
        if (typeof budgetVariantUUID !== 'string') {
            console.error('Cannot define budget variant UUID');
            return;
        }

        const budgetProgramCode = this.budgetProgram?.prg;
        if (typeof budgetProgramCode !== 'number') {
            console.error('Cannot define budget program code');
            return;
        }

        const form = this.form;
        if (form === null) {
            console.error('Report form is NULL');
            return;
        }

        const versionId = this.version?.id ?? null;
        if (typeof versionId !== 'number') {
            console.error('Version ID is null');
            return;
        }

        const budgetSubprogramCode = this.budgetSubprogram?.ppr ?? null;

        const reportYear = this.reportYear;
        const debugging = this.debugging;

        let reportType: ('COMMON' | 'DETAILED');
        if (this.detailedReport) {
            reportType = 'DETAILED';
        } else {
            reportType = 'COMMON';
        }

        action(regionCode, budgetVariantUUID, budgetProgramCode, budgetSubprogramCode, form, versionId, reportYear, debugging, reportType);
    }

    public generateAndDownloadReport() {
        this.generateReportUsingSettings((regionCode, budgetVariantUUID, budgetProgramCode, budgetSubprogramCode, form, versionId, reportYear, debugging, reportType) => {
            const url = this.prepareUrl(
                '/api/budget/staffing_table/report-v2/form-report.zip',
                [
                    ['region',            regionCode],
                    ['version',           versionId],
                    ['budget-variant',    budgetVariantUUID],
                    ['budget-program',    budgetProgramCode],
                    ['budget-subprogram', budgetSubprogramCode],
                    ['form',              form],
                    ['year',              reportYear],
                    ['debugging',         debugging],
                    ['report-type',       reportType],
                ],
            );
            this.openUrl(url);
        });
    }


    public generatingAndSavingReport = false;

    public generateAndSaveReport() {
        if (this.generatingAndSavingReport) {
            console.error('Cannot generate and save report - another generation is running');
        }

        this.generateReportUsingSettings((regionCode, budgetVariantUUID, budgetProgramCode, budgetSubprogramCode, form, versionId, reportYear, debugging, reportType) => {
            const url = this.prepareUrl(
                '/api/budget/staffing_table/report-v2/generate',
                [
                    ['version',           versionId],
                    ['region',            regionCode],
                    ['budget-variant',    budgetVariantUUID],
                    ['budget-program',    budgetProgramCode],
                    ['budget-subprogram', budgetSubprogramCode],
                    ['form',              form],
                    ['year',              reportYear],
                    ['debugging',         debugging],
                    ['report-type',       reportType],
                ],
            );

            this.generatingAndSavingReport = true
            this.request<Report2>(
                { url, method: 'POST' },
                (data) => {
                    this.$emit(events.reportSaved, data);
                },
                () => (this.i18nDb.translateByKey('modules.budget.staffing-table.reports.*GenerationPane*.errors.cannot-generate-and-save-report')),
                () => {
                    this.generatingAndSavingReport = false;
                },
            );
        });
    }
    // endregion

    private areRequiredSettingFilled(
        action: (settings: ReportSettings) => void
    ) {
        const variantUuid = this.budgetVariant?.variantUuid ?? null
        if (variantUuid == null) {
            this.toast('info', 'Ошибка фильтра', `Выберите версию бюджета`);
            console.error('Cannot define budget variant UUID');
            return;
        }

        const staffTabVersionId = this.version?.id ?? null
        if (staffTabVersionId == null) {
            this.toast('info', 'Ошибка фильтра', `Выберите версию штатного расписания`);
            console.error('Version ID is null');
            return;
        }
       const abpCode = this.abpCode
        if (abpCode == null) {
            this.toast('info', 'Ошибка фильтра', `Укажите - АБП`);
            console.error('ABP is null');
            return;
        }


        const budgetProgramCode = this.budgetProgram?.prg ?? null;

        const detailedReport = this.detailedReport;
        const debugging = this.debugging;

        const settings: ReportSettings = {
            budgetVariantUUID: variantUuid,
            abpCode: abpCode,
            staffTabVersionId: staffTabVersionId,
            budgetProgramCode: budgetProgramCode,
            detailedReport: detailedReport,
            debug: debugging
        };

        // Вызываем переданную функцию с параметрами settings
        action(settings);
    }


    generateStaffingTableReport(generatorType: string, isEdu: boolean) {
        this.areRequiredSettingFilled((settings) => {
            const locale = i18n.locale

            const url = this.prepareUrl(
                '/api/budget/staffing_table/staffing-table-report/generate',
                [
                    ['staff-tab-versionId',   settings.staffTabVersionId],
                    ['variant-uuid',      settings.budgetVariantUUID],
                    ['abp-code',      settings.abpCode],
                    ['budget-program-code', settings.budgetProgramCode],
                    ['generator-type', generatorType],
                    ['education', isEdu],
                    ['detailedReport', settings.detailedReport],
                    ['debug', settings.debug],
                    ['locale', locale],
                ],
            );
                 window.open(url, '_blank');

            }
        )
    }
}
